<footer fxFlex="100%" class="footer">
  <p class="footer-copyright">
    APP <abbr class="abbreviation" title="Copyright">&copy;</abbr> Projeto
    Inovação 2022 - {{version}}
  </p>
</footer>
